import { useCallback, useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { EmbeddedLayout } from "../components/EmbeddedLayout";
import { FlowAddPaymentMethod } from "../../Settings/components/payment/FlowAddPaymentMethod";
import { ManagePaymentMethod } from "../../Settings/components/payment/ManagePaymentMethod";
import {
  PATH_EMBEDDED_MANAGE_PAYMENT_METHOD,
  PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD
} from "../paths";
import { parseAllowedPaymentMethods } from "../utils/parseAllowedPaymentMethods";
import { sendMessageToParent } from "../utils/postMessage";

export const RouteManagePaymentMethod: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [availableMethods] = useState(() => {
    const params = new URLSearchParams(location.search);
    const allowedMethods = parseAllowedPaymentMethods(
      params.get("allowedMethods") || ""
    );
    // Empty array means "no restriction" — pass undefined so
    // FlowAddPaymentMethod shows every available method.
    return allowedMethods.length > 0 ? allowedMethods : undefined;
  });

  const goBackToManage = useCallback(() => {
    history.push(PATH_EMBEDDED_MANAGE_PAYMENT_METHOD);
  }, [history]);

  return (
    <EmbeddedLayout>
      <Switch>
        <Route path={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD}>
          <FlowAddPaymentMethod
            basePath={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD}
            availableMethods={availableMethods}
            onBack={goBackToManage}
            onNext={goBackToManage}
          />
        </Route>

        <Route path={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD}>
          <ManagePaymentMethod
            onNext={() => sendMessageToParent("complete", { changed: true })}
            onAddNew={() => {
              history.push(PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD);
            }}
          />
        </Route>
      </Switch>
    </EmbeddedLayout>
  );
};
